import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const PriceTag32: FC<IconV2Props> = ({ icon, chroma, className }) => (
  <svg
    className={cn(
      chroma === 'light' && s.svgLight32,
      `svg-icon--${icon}`,
      className
    )}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={`${icon}-32`}
  >
    <defs>
      <path id="a" d="M0 0h32v32H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <path
        d="m17.351 1.524 7.5 8v19h-15v-19l7.5-8Zm0 2.192-6 6.4v16.908h12V10.117l-6-6.401Z"
        fill="#000"
        fillRule="nonzero"
        mask="url(#b)"
        transform="rotate(45 17.351 15.024)"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        mask="url(#b)"
        transform="rotate(45 25.483 6.892)"
        d="M26.233 1.642v10.5h-1.5v-10.5z"
      />
      <path
        d="M20.18 9.196a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        fill="#000"
        fillRule="nonzero"
        mask="url(#b)"
        transform="rotate(45 20.18 12.196)"
      />
      <g mask="url(#b)">
        <path
          d="M12.17 13.99c.23-.14.47-.225.718-.254.268-.028.511-.003.73.078.249.075.487.226.714.453.224.224.377.465.46.72.083.222.106.463.07.724-.024.228-.106.47-.247.725a3.54 3.54 0 0 1-.515.65c-.208.208-.426.381-.654.52a1.783 1.783 0 0 1-.703.254c-.26.031-.507.008-.738-.07-.241-.078-.482-.236-.72-.476-.24-.239-.399-.48-.477-.72a1.87 1.87 0 0 1-.07-.738c.037-.256.122-.49.255-.703a3.476 3.476 0 0 1 1.177-1.162Zm.101 1.268a2.98 2.98 0 0 0-.352.412c-.097.126-.17.26-.222.402a.66.66 0 0 0-.036.357.618.618 0 0 0 .18.314c.102.102.209.164.32.187.118.023.237.011.358-.036.137-.051.273-.123.41-.214a2.98 2.98 0 0 0 .754-.739c.095-.126.167-.258.214-.394a.731.731 0 0 0 .043-.38.541.541 0 0 0-.176-.347.609.609 0 0 0-.348-.176.717.717 0 0 0-.372.05 1.287 1.287 0 0 0-.394.215 7.799 7.799 0 0 0-.379.349Zm-2.83 5.29-.68-.68 8.629-2.684.658.658L9.44 20.55Zm3.383.192c.2-.2.418-.374.654-.52.255-.14.497-.222.725-.246.268-.034.512-.008.73.077.25.075.487.227.714.453.224.225.374.461.45.71.082.221.11.466.08.734a1.861 1.861 0 0 1-.258.714c-.135.24-.305.463-.507.665a3.18 3.18 0 0 1-.65.508c-.221.141-.457.23-.707.266a1.759 1.759 0 0 1-.742-.073c-.244-.08-.483-.238-.717-.472-.24-.24-.398-.48-.476-.721a1.744 1.744 0 0 1-.073-.742c.036-.25.125-.486.265-.707.129-.218.3-.433.512-.646Zm.748.748c-.09.089-.205.225-.349.408a1.66 1.66 0 0 0-.21.413.745.745 0 0 0-.04.361.618.618 0 0 0 .18.314.609.609 0 0 0 .31.176c.146.018.269.007.368-.032a1.44 1.44 0 0 0 .413-.21c.126-.087.262-.204.408-.35.12-.118.233-.247.342-.386.099-.129.169-.261.21-.398a.782.782 0 0 0 .055-.39.662.662 0 0 0-.184-.333.672.672 0 0 0-.336-.187.763.763 0 0 0-.383.047 1.671 1.671 0 0 0-.398.225 4.285 4.285 0 0 0-.386.342Z"
          fill="#000"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
);

export default PriceTag32;
